export const POSITIONS_PRIORITY = [
  "CEO",
  "CISO",
  "CIO",
  "CTO",
  "Technology Manager",
  "Chief Information Officer",
  "Chief Technology Officer",
  "Seguridad",
  "Security",
  "Tech Lead",
  "Cybersecurity",
  "Director",
  "Founder",
  "Co-founder",
  "Software",
  "Manager",
  "Executive",
  "Administrative",
  "Owner",
  "Propietario",
  "Presidente",
  "Fundador",
  "Miembro",
  "TIC",
];